import type { ColumnDefProps } from '@components/shared/Table/types'
import type { DetailedSummaryResponseProps } from './mocks/detailedSummaryMock'

interface ParseDetailedSummaryProps {
  data: DetailedSummaryResponseProps[]
}

export const parseDetailedSummaryGrid = ({ data }: ParseDetailedSummaryProps) => {
  if (!data) return []

  const parsedData: ColumnDefProps[][] = data.map((item) => [
    {
      id: 'category',
      columnName: 'Categoria',
      align: 'center',
      value: item.category
    },
    {
      id: 'totalValue',
      columnName: 'Valor Total',
      align: 'center',
      value: item.totalValue,
      currency: true
    },
    {
      id: 'percentageValue',
      columnName: 'Valor (%)',
      align: 'center',
      value: item.percentageValue ? `${item.percentageValue}%`.replace('.', ',') : '-'
    }
  ])

  return parsedData
}
